








































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import MarkedEditor from '@/components/marked/markedEditor.vue';

type IUpdateIssueInfo = IIssue.IRequest.IUpdateIssueInfo;
interface IForm {
  title: string;
  description: string;
  urgency: number;
}

@Component({
  components: {
    MarkedEditor,
  },
})
export default class EditIssue extends Vue {
  private submitLoading: boolean = false;
  get formTitle() {
    if (this.isCreate) {
      return this.$t('issue.create');
    } else {
      return this.issueInfo.title;
    }
  }
  @Ref() private readonly editIssueForm!: FormModel;
  private rules = {
    title: [
      {
        required: true,
        message: () => this.$t('form.required'),
        trigger: 'blur',
      },
    ],
    description: [
      {
        required: true,
        message: () => this.$t('form.required'),
        trigger: 'blur',
      },
    ],
  };
  @Prop({ default: true }) private isCreate!: boolean;
  @Prop({ required: true }) private submit!: (
    updateInfo: IUpdateIssueInfo,
  ) => Promise<string>;
  @Prop({ required: true }) private issueInfo!: IUpdateIssueInfo;
  private form: IForm = {
    title: '',
    description: '',
    urgency: 0,
  };
  private created() {
    this.initFormData();
  }
  private initFormData() {
    this.form = {
      title: this.issueInfo.title,
      description: this.issueInfo.description,
      urgency: this.issueInfo.urgency,
    };
  }
  private handleSubmit() {
    this.editIssueForm.validate((valid) => {
      if (valid) {
        const { description, title, urgency } = this.form;
        const updateInfo: IUpdateIssueInfo = {
          title,
          description,
          urgency,
        };
        this.submitIssue(updateInfo);
      } else {
        return false;
      }
    });
  }
  private submitIssue(updateInfo: IUpdateIssueInfo) {
    this.submitLoading = true;
    this.submit(updateInfo).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.submitLoading = false;
    });
  }
  private updateDescription(description: string) {
    this.form.description = description;
  }
  private goBack() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.go(-1);
  }
}
